import AppointmentList from "@/app/subs/appointments";
import AppointmentUpdate from "@/app/subs/appointments/update";
import AppointmentCalendarPage from "@/app/subs/appointments/calendar.page";
import IndividualsPage from "@/app/subs/individuals/individuals.page";
import IndividualDetailPage from "@/app/subs/individuals/detail";
import Home from "@/app/subs/home";
import Services from "@/app/subs/services";
import DailyWorkPage from "@/app/subs/daily-work/daily-work.page";
import DailyWorkExecutionDetail from "@/app/subs/daily-work/execution-detail";
import PaymentDuesPage from "@/app/subs/payment-dues/payment-dues.page";
import StripeConnectSettingsPage from "@/app/subs/settings/stripe-connect/stripe-connect.page";

export const subs_routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/appointments",
    element: <AppointmentList />,
  },
  {
    path: "/appointments/calendar",
    element: <AppointmentCalendarPage />,
  },
  {
    path: "/appointments/:appointmentId",
    element: <AppointmentUpdate />,
  },
  {
    path: "/individuals",
    element: <IndividualsPage />,
  },
  {
    path: "/individuals/:individualId",
    element: <IndividualDetailPage />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/daily-work",
    element: <DailyWorkPage />,
  },
  {
    path: "/daily-work/:dayId/execution",
    element: <DailyWorkExecutionDetail />,
  },
  {
    path: "/daily-work/:dayId/execution/:executionId",
    element: <DailyWorkExecutionDetail />,
  },
  {
    path: "/payment-dues",
    element: <PaymentDuesPage />,
  },
  {
    path: "/settings/stripe-connect",
    element: <StripeConnectSettingsPage />,
  },
];
